// extracted by mini-css-extract-plugin
module.exports = {"viewport":"_2DYqu1VyRshjaMvrk5dGhA","browserCard":"_21kdwLKIsvJug9VW1cE__k","listGroup":"_2E6EPxeImvqCJXqeRlUK50"};